/*
  Otaku TCG motion: scroll reveals ("dealt" cards), card tilt and glare, the hero's
  pointer light, sparkle bursts, the cart bump and the ticker pause. (The page-transition
  fallback lives inline in snippets/otcg-page-transition.liquid.)

  Progressive enhancement: content is visible by default. Hiding styles in otcg-base.css
  only apply under html.otcg-motion, which this script adds when motion is allowed, so if
  JS fails nothing is hidden. Only transform and opacity animate. Scroll-linked effects
  (hero parallax, the giveaway pack) are CSS scroll-driven animations, not JS.
*/
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function motionOK() {
    return !reduce.matches;
  }

  /* ---------- Hero decoration: one frame after the first paint (also under reduced motion) ---------- */
  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(function () {
      root.classList.add('otcg-stage-on');
    });
  });

  /* ---------- Ticker pause (works under reduced motion too, where the band is still) ---------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-otcg-ticker-pause]');
    if (!button) return;
    var ticker = button.closest('[data-otcg-ticker]');
    if (!ticker) return;
    var paused = ticker.classList.toggle('is-paused');
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
  });

  if (!motionOK()) return;

  /* ---------- Sparkle burst ---------- */
  var SPARK_COLOURS = ['#ff0073', '#6a33d8', '#ffffff', '#ff7ac1', '#ffe66d'];

  function burst(el) {
    if (!motionOK() || !el || !el.getBoundingClientRect || typeof el.animate !== 'function') return;
    var rect = el.getBoundingClientRect();
    var layer = document.createElement('div');
    layer.className = 'otcg-sparks';
    layer.setAttribute('aria-hidden', 'true');
    layer.style.transform = 'translate(' + (rect.left + rect.width / 2) + 'px,' + (rect.top + rect.height / 2) + 'px)';
    var count = 14;
    for (var i = 0; i < count; i++) {
      var spark = document.createElement('span');
      spark.className = 'otcg-spark';
      spark.style.setProperty('--spark', SPARK_COLOURS[i % SPARK_COLOURS.length]);
      layer.appendChild(spark);
      var angle = (i / count) * Math.PI * 2 + Math.random() * 0.45;
      var reach = Math.max(rect.width * 0.42, 46) + Math.random() * 42;
      var dx = Math.cos(angle) * reach;
      var dy = Math.sin(angle) * reach * 0.8;
      var size = 0.8 + Math.random() * 0.8;
      spark.animate(
        [
          { transform: 'translate(0, 0) scale(0) rotate(0deg)', opacity: 1 },
          { transform: 'translate(' + dx * 0.62 + 'px,' + dy * 0.62 + 'px) scale(' + size + ') rotate(80deg)', opacity: 1, offset: 0.45 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0) rotate(170deg)', opacity: 0 },
        ],
        { duration: 650 + Math.random() * 300, easing: 'cubic-bezier(0.2, 0.8, 0.3, 1)', fill: 'forwards' }
      );
    }
    document.body.appendChild(layer);
    window.setTimeout(function () {
      layer.remove();
    }, 1100);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var button = event.submitter || (form.querySelector && form.querySelector('[type="submit"]'));
      if (!button) return;
      var isCartAdd = /\/cart\/add/.test(form.getAttribute('action') || '');
      if (isCartAdd || button.hasAttribute('data-otcg-sparkle')) burst(button);
    },
    true
  );

  document.addEventListener('click', function (event) {
    var el = event.target.closest && event.target.closest('[data-otcg-sparkle]');
    if (!el || el.type === 'submit') return;
    burst(el);
  });

  /* ---------- Cart icon bump ---------- */
  function bumpCart() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('otcg-bump');
    void icon.offsetWidth; /* restart the animation */
    icon.classList.add('otcg-bump');
  }

  /* PUB_SUB_EVENTS is a top-level const in constants.js: a global binding, not a window property. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && (event.source === 'product-form' || event.source === 'quick-add')) bumpCart();
    });
  }

  /* ---------- Scroll reveals ---------- */
  if (!('IntersectionObserver' in window)) return;

  var SINGLE = [
    '.otcg-section__head',
    '.otcg-giveaways__intro',
    '.otcg-giveaway-card',
    '.otcg-whatsapp__card',
    '.otcg-panel',
    '.otcg-past__title',
    '.otcg-404__card',
    '.otcg-more-row',
    '.otcg-empty',
    '.newsletter__wrapper',
    '.contact form',
    '.cart__footer .cart__blocks',
    '.otcg-coming__card',
  ].join(',');

  /* Lists whose children are dealt in like cards. */
  var DEAL = [
    '.otcg-types__grid',
    '.otcg-product-grid',
    '.otcg-steps__list',
    '.otcg-past__list',
    '#product-grid',
    '.product-grid',
    'product-recommendations .grid',
    '.otcg-account__breakdown',
    '.otcg-account__past-list',
    '.otcg-account__side',
    '.otcg-account__layout--out',
  ].join(',');

  /* Lists whose children simply rise in. */
  var STAGGER = '.otcg-footer__grid';

  function inFirstView(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight * 0.92 && r.bottom > 0;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  function watch(el) {
    if (inFirstView(el)) el.classList.add('is-inview');
    else observer.observe(el);
  }

  function prepareList(list, mode) {
    var children = Array.prototype.slice.call(list.children);
    var columns = 1;
    if (children.length > 1) {
      var top = children[0].getBoundingClientRect().top;
      columns =
        children.filter(function (child) {
          return Math.abs(child.getBoundingClientRect().top - top) < 4;
        }).length || 1;
    }
    children.forEach(function (child, index) {
      if (child.hasAttribute('data-reveal')) return;
      child.setAttribute('data-reveal', mode);
      var column = index % columns;
      child.style.setProperty('--reveal-delay', Math.min(column + Math.floor(index / columns), 8) * 80 + 'ms');
      if (mode === 'deal') {
        /* Outer columns lean outwards, inner ones barely: a hand of cards settling. */
        var lean = columns > 1 ? (column / (columns - 1) - 0.5) * 2 : index % 2 ? 0.6 : -0.6;
        child.style.setProperty('--deal-r', (lean * 6).toFixed(1) + 'deg');
      }
      watch(child);
    });
  }

  function prepare(scope) {
    var context = scope || document;
    context.querySelectorAll(SINGLE).forEach(function (el) {
      if (el.hasAttribute('data-reveal') || el.closest('.scroll-trigger')) return;
      el.setAttribute('data-reveal', '');
      watch(el);
    });
    context.querySelectorAll(DEAL).forEach(function (list) {
      prepareList(list, 'deal');
    });
    context.querySelectorAll(STAGGER).forEach(function (list) {
      prepareList(list, '');
    });
  }

  /* ---------- Hero: pointer light and card tilt (mouse and pen) ---------- */
  function setupHero() {
    if (!finePointer) return;
    var hero = document.querySelector('.otcg-hero');
    if (!hero) return;
    var frame = 0;
    var px = 0;
    var py = 0;
    function apply() {
      frame = 0;
      hero.style.setProperty('--px', px.toFixed(3));
      hero.style.setProperty('--py', py.toFixed(3));
    }
    function queue() {
      if (!frame) frame = window.requestAnimationFrame(apply);
    }
    hero.addEventListener(
      'pointermove',
      function (event) {
        if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
        var r = hero.getBoundingClientRect();
        px = Math.max(-1, Math.min(1, ((event.clientX - r.left) / r.width - 0.5) * 2));
        py = Math.max(-1, Math.min(1, ((event.clientY - r.top) / r.height - 0.5) * 2));
        queue();
      },
      { passive: true }
    );
    hero.addEventListener('pointerleave', function () {
      px = 0;
      py = 0;
      queue();
    });
  }

  /* ---------- Cards and tiles: 3D tilt with a glare that follows the pointer ---------- */
  function setupTilt() {
    if (!finePointer) return;
    var active = null;
    var last = null;
    var frame = 0;

    function cardFrom(target) {
      if (!target || !target.closest) return null;
      var tile = target.closest('.otcg-tile__link');
      if (tile) return tile;
      var wrapper = target.closest('.card-wrapper');
      return wrapper ? wrapper.querySelector('.card--card') : null;
    }

    function release(card) {
      card.classList.remove('is-tilting');
      ['--rx', '--ry', '--gx', '--gy'].forEach(function (name) {
        card.style.removeProperty(name);
      });
    }

    function apply() {
      frame = 0;
      if (!active || !last) return;
      /* Measure the untilted parent so the tilt never feeds back into itself. */
      var r = active.parentElement.getBoundingClientRect();
      var x = Math.max(0, Math.min(1, (last.clientX - r.left) / r.width));
      var y = Math.max(0, Math.min(1, (last.clientY - r.top) / r.height));
      active.style.setProperty('--rx', ((0.5 - y) * 9).toFixed(2) + 'deg');
      active.style.setProperty('--ry', ((x - 0.5) * 11).toFixed(2) + 'deg');
      active.style.setProperty('--gx', ((x - 0.5) * 50).toFixed(1) + '%');
      active.style.setProperty('--gy', ((y - 0.5) * 50).toFixed(1) + '%');
    }

    document.addEventListener(
      'pointermove',
      function (event) {
        if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
        var card = cardFrom(event.target);
        if (card !== active) {
          if (active) release(active);
          active = card;
          if (card) card.classList.add('is-tilting');
        }
        if (!card) return;
        last = event;
        if (!frame) frame = window.requestAnimationFrame(apply);
      },
      { passive: true }
    );

    document.documentElement.addEventListener('mouseleave', function () {
      if (active) release(active);
      active = null;
    });
  }

  function init() {
    prepare(document);
    root.classList.add('otcg-motion');
    setupHero();
    setupTilt();

    /* Facets and sorting re-render the collection grid. */
    var grid = document.getElementById('ProductGridContainer');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () {
        prepare(grid);
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (event) {
    prepare(event.target);
  });

  if (reduce.addEventListener) {
    reduce.addEventListener('change', function (event) {
      if (event.matches) root.classList.remove('otcg-motion');
    });
  }
})();
